module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAA50lEQVR4Ae3REUyFYRhA4eBivnz5csrd3cMwDMPwYs4Xcwp/CHIKghNGrfqDb3v3PL4j5wwAAAAAAAAAAAAAAAAAAKC6rO6q52qrtupU3VYX8/uLVIfqvvroe+/Vzez+AtWhOvV7x7n9BaqH/u5mXn+B6qp93quLWf0Fqsf2u53VX6Da2u80q79A/7MN6K/V/7wO6K9VvbXf84D+WtWx/e4G9Neqrtvno7oc0F+veurv7of016vOq5d+71Qd5vXXT3jqZw/VYWh/veq6OlZvfdmqx+pqen8+AAAAAAAAAAAAAAAAAADgE+ODGvHPaLLuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/more-white-icon.png
// module id = 405
// module chunks = 0